import { Modal, Cascader, Form, Typography } from "antd";
import { allRoles, rolePrettyNames } from "../constants/roles";

const { Text } = Typography;

const roleOptions = allRoles.map((role) => ({
  value: role,
  label: rolePrettyNames[role] ?? role,
  disabled: role === "DASHBOARD_USER",
}));

const BatchRoleModal = ({
  selectedUsers, // User[]
  isLoading,
  isOpen,
  onClose,
  onConfirm, // (roles: string[]) => void
}) => {
  const [form] = Form.useForm();

  const handleOk = () => form.submit();

  const handleFinish = ({ roles }) => {
    onConfirm(roles ? roles.flat(Infinity) : []);
  };

  return (
    <Modal
      title={`Batch Change Roles`}
      open={isOpen}
      onOk={handleOk}
      onCancel={onClose}
      okText="Apply to Selected"
      confirmLoading={isLoading}
      destroyOnClose
    >
      <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
        This will replace the roles for{" "}
        <Text strong>{selectedUsers.length} selected user{selectedUsers.length !== 1 ? "s" : ""}</Text>.
      </Text>
      <Form form={form} layout="vertical" onFinish={handleFinish} preserve={false}>
        <Form.Item
          label="New Roles"
          name="roles"
          rules={[{ required: true, message: "Select at least one role" }]}
        >
          <Cascader
            options={roleOptions}
            multiple
            maxTagCount="responsive"
            showSearch={{
              filter: (input, path) =>
                path.some((o) => o.label.toLowerCase().includes(input.toLowerCase())),
            }}
            placeholder="Select roles to assign"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BatchRoleModal;